import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import SearchIcon from '@material-ui/icons/Search';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useRecoilState} from 'recoil';
import classNames from 'classnames';
import {loadingState} from '../../atoms';
import SearchButton from '../SearchButton/SearchButton';
import SearchInput from '../SearchInput/SearchInput';
import getAlphanumericText from '../../utilis/getAlphanumericText';

interface ISearchBarProps {
  onSearch: (text: string) => void;
  defaultValue: string,
}

const SearchBar = ({onSearch, defaultValue: value}: ISearchBarProps) => {
  const theme = useTheme();
  const smaller = useMediaQuery(theme.breakpoints.down('xs'));
  const {t} = useTranslation();
  const [input, setInput] = useState(getAlphanumericText(value));
  const [loading] = useRecoilState(loadingState);
  
  return (
    <div className={classNames('search-bar-container', {'mobile': smaller})}>
      <div className={'search-input-container'}>
        <SearchInput
          label={t('search-bar.input-label')}
          fullWidth value={input}
          onChange={(event) => setInput(getAlphanumericText(event.target.value))}
          disabled={loading}
          onKeyDown={(event) => event.key === 'Enter' && onSearch(input)}
        />
      </div>
      <div className={'search-button-wrapper'}>
        <div className={'search-button-container'}>
          <SearchButton variant="contained" fullWidth onClick={() => onSearch(input)} disabled={loading}>
            {t('search-bar.button-label')}
            <SearchIcon className={'search-button-icon'} />
          </SearchButton>
        </div>
      </div>
    </div>
  )
}

export default SearchBar
